import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Col, Row } from 'antd';

import { PLAN_DATE_FORMAT } from '../../constants';

import InfoCard, { CardRow } from '../InfoCard';

const propTypes = {
  cars: PropTypes.arrayOf(
    PropTypes.shape({
      VRN: PropTypes.string.isRequired,
      annualMileage: PropTypes.number.isRequired,
      currentMileage: PropTypes.number.isRequired,
      carFirstRegistered: PropTypes.string.isRequired,
      lastServiceDate: PropTypes.string.isRequired,
      lastServiceMileage: PropTypes.number.isRequired,
      makerName: PropTypes.string,
      modelName: PropTypes.string,
    }).isRequired,
  ),
};
const defaultProps = {
  cars: [],
};

const CarsList = ({ cars }) => (
  <Row gutter={16}>
    {cars.map(car => {
      const description = (
        <CardRow>
          <span>{car.VRN}</span>
          <span>{moment(car.carFirstRegistered).format(PLAN_DATE_FORMAT)}</span>
        </CardRow>
      );
      return (
        <Col span={5} key={car.VRN}>
          <InfoCard
            loading={!car.makerName}
            title={`${car.makerName} ${car.modelName}`}
            description={description}
            data={car}
            fields={[
              {
                id: 'currentMileage',
                title: 'Current mileage',
              },
              {
                id: 'annualMileage',
                title: 'Annual mileage',
              },
              {
                id: 'lastServiceDate',
                title: 'Last Service date',
                render: lastServiceDate =>
                  moment(lastServiceDate).format(PLAN_DATE_FORMAT),
              },
              {
                id: 'lastServiceMileage',
                title: 'Last Service mileage',
              },
            ]}
          />
        </Col>
      );
    })}
  </Row>
);

CarsList.propTypes = propTypes;
CarsList.defaultProps = defaultProps;

const mapStateToProps = ({ admin: { planCarsList } }) => ({
  cars: planCarsList,
});

export default connect(mapStateToProps)(CarsList);
